/*
 * @flow
 * Author: Chinmaya
 */

import styled, { css } from 'react-emotion'

// 14, 18, 12, 22
export const RobotoRegular = styled('p')`
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
`
// 16, 18
export const RobotoMedium = styled('p')`
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
`

// 14
export const RobotoItalic = styled('p')`
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-style: italic;
`

// 46, 30, 32, 22, 16, 18
export const RobotoLight = styled('p')`
  font-family: Roboto;
  font-size: 18px;
  font-weight: 300;
`
export const RobotoLightLarge = styled(RobotoLight)`
  font-size: 46px;
`
export const RobotoLightMeduim = styled(RobotoLight)`
  font-size: 22px;
`
export const RobotoLightSmall = styled(RobotoLight)`
  font-size: 16px;
`
export const RobotoLightMeduimSoft = styled(RobotoLightMeduim)`
  font-weight: 300;
  font-size: 22px;
  letter-spacing: -0.9px;
  color: #ffffff;
`
export const RobotoThickMedium = styled(RobotoMedium)`
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #ffffff;
  margin: 0px;
`
